import { Helmet } from "react-helmet-async";

const SITE = "Smart News Italia";
const SITE_ORIGIN = "https://smartnewsitalia.it";
const DEFAULT_TITLE = "Smart News Italia | Discorsi e dichiarazioni tradotti in italiano";
const DEFAULT_DESC =
  "Discorsi, dichiarazioni e conferenze stampa dei leader mondiali tradotti in italiano, con video originale, testo integrale e fonte ufficiale verificabile.";
const DEFAULT_OG_IMAGE = `${SITE_ORIGIN}/og-default.jpg`;
const DEFAULT_OG_W = 1200;
const DEFAULT_OG_H = 630;

// Sistema centralizzato per TUTTI i metadati SEO/social: unica istanza per pagina.
export default function SEO({
  title,
  description,
  image,
  imageWidth,
  imageHeight,
  imageAlt,
  type = "website",
  canonicalPath,
  noindex = false,
  robots,
  suppressCanonical = false,
  jsonLd,
}) {
  const fullTitle = title ? `${title} | ${SITE}` : DEFAULT_TITLE;
  const desc = description || DEFAULT_DESC;

  const path =
    canonicalPath != null
      ? canonicalPath
      : typeof window !== "undefined"
      ? window.location.pathname
      : "/";
  const canonical = `${SITE_ORIGIN}${path}`;

  const img = image || DEFAULT_OG_IMAGE;
  const isDefaultImg = img === DEFAULT_OG_IMAGE;
  const w = imageWidth || (isDefaultImg ? DEFAULT_OG_W : undefined);
  const h = imageHeight || (isDefaultImg ? DEFAULT_OG_H : undefined);
  const alt = imageAlt || fullTitle;

  const robotsContent = robots || (noindex ? "noindex, follow" : null);
  const ldArray = jsonLd ? (Array.isArray(jsonLd) ? jsonLd : [jsonLd]) : [];

  return (
    <Helmet prioritizeSeoTags>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />
      {robotsContent && <meta name="robots" content={robotsContent} />}
      {!suppressCanonical && <link rel="canonical" href={canonical} />}
      {/* Open Graph */}
      <meta property="og:site_name" content={SITE} />
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />
      {w && <meta property="og:image:width" content={String(w)} />}
      {h && <meta property="og:image:height" content={String(h)} />}
      <meta property="og:image:alt" content={alt} />
      {!suppressCanonical && <meta property="og:url" content={canonical} />}
      <meta property="og:locale" content="it_IT" />
      {/* Twitter / X */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
      <meta name="twitter:image:alt" content={alt} />
      {ldArray.map((obj, i) => (
        <script key={obj["@type"] || i} type="application/ld+json">
          {JSON.stringify(obj)}
        </script>
      ))}
    </Helmet>
  );
}
